import {optEmptyString} from 'ts-opt';

import {BreedingFemale} from 'api/gen/BreedingFemale';
import {CabBreedingFemale} from 'api/gen/CabBreedingFemale';
import {CabCalf} from 'api/gen/CabCalf';

/** Minimal data required to build a Plemdat animal-browser link. */
export type AnimalBrowserLinkProps = Pick<BreedingFemale, 'huid' | 'earTag'>;

/**
 * Builds the external Plemdat animal-browser URL for a breeding female or calf.
 *
 * @param params Ear-tag and optional HUID values used in the external browser query.
 * @returns The Plemdat animal-browser URL.
 *
 * @example
 * getAnimalBrowserLink({earTag: 'CZ123456789', huid: '12345'});
 */
export const getAnimalBrowserLink = ({
    earTag,
    huid,
}: AnimalBrowserLinkProps | CabBreedingFemale | CabCalf): string =>
    `https://test.plemdat.cz/krava/krava?&povel=Hledej&USCIS=${earTag ?? ''}\
${optEmptyString(huid).map(x => `&HUID=${x}`).orElse('')}`;

/**
 * Adapts a table row into an external Plemdat animal-browser URL.
 *
 * @param _id Unused row id required by the table-link callback signature.
 * @param row Table row carrying the ear-tag and optional HUID values.
 * @returns The Plemdat animal-browser URL for the row.
 */
export const getAnimalBrowserLinkForTable = (
    _id: number | string,
    row: AnimalBrowserLinkProps | CabBreedingFemale | CabCalf,
): string => getAnimalBrowserLink(row);
